<div class="form_container">
  <usimweb-form-input [value]="person.name" class="input" class="form_width" placeholder="First name" [readonly]="true"></usimweb-form-input>
  <usimweb-form-input [value]="person.lastName" class="input" class="form_width" placeholder="Last name" [readonly]="true"></usimweb-form-input>
  <usimweb-form-input [value]="person.mail" class="input" class="form_width" placeholder="Business Email" [readonly]="true"></usimweb-form-input>
</div>

<div class="text_container">
  <usimweb-checkbox (onChange)="toggleConsent($event)"></usimweb-checkbox>

  <p class="consent_text">
    I agree that BASF SE and its affiliated companies (“BASF”) can contact me via the selected communication channels for the purpose of informing me about BASF products, services
    and events which BASF considers relevant for me and conducting customer surveys.<br />
    In order to determine which information is relevant for me, BASF may collect and analyze information about my professional needs and interests (including those derived from my
    interactions with these marketing messages) and from my overall customer relationship with BASF. <br />
    Further details about the scope of my consent and about my right to withdraw it at any time can be found
    <a href="https://ultrasimweb.basf.com/marketing-consent/" target="_blank">here.</a>
    <br />
    Information on the processing and protection of personal data within BASF can be found under:
    <a href="https://ultrasimweb.basf.com/molded/data_privacy/" target="_blank">Data Privacy Policy.</a>
  </p>
</div>

<usimweb-button class="submit_button" [disabled]="isSubmitDisabled" (btnClick)="permitConsent()" text="Submit"></usimweb-button>

 <div class="feedback_comparison">
  <div style="margin-right: 20px">
    <p>How we work without feedback</p>
    <div class="iconstyle"><usimweb-icon icon="sentiment_very_dissatisfied"></usimweb-icon><usimweb-icon icon="battery_2_bar"></usimweb-icon></div>
  </div>
  <div >
    <p>How we work with feedback</p>
    <div class="iconstyle"><usimweb-icon icon="sentiment_very_satisfied"></usimweb-icon><usimweb-icon icon="rocket_launch"></usimweb-icon></div>
  </div>
</div> 
